import React from "react";
import { SpinnerLoader, SpinnerWrap } from "./styles";

const Spinner = () => {
  return (
    <SpinnerWrap>
      <SpinnerLoader />
    </SpinnerWrap>
  );
};

export default Spinner;
